import Handlebars from 'handlebars';

export default Handlebars.compile(`
<img class='modal-img-second' src='{{images.8.url}}' alt='{{name}}' />
<div class='timer-align'>
  <h3 class='timer-title'>This event will come in :</h3>
  <div class='timer' id='timer-1'>
    <div class='field'>
      <span class='value' data-value='days'>--</span>
      <span class='label'>Days</span>
    </div>

    <div class='field'>
      <span class='value' data-value='hours'>--</span>
      <span class='label'>Hours</span>
    </div>

    <div class='field'>
      <span class='value' data-value='mins'>--</span>
      <span class='label'>Minutes</span>
    </div>

    <div class='field'>
      <span class='value' data-value='secs'>--</span>
      <span class='label'>Seconds</span>
    </div>
  </div>
</div>
<div class='modal-hero'>
  <img class='modal-img-first' src='{{images.1.url}}' alt='{{name}}' />
  <div class='modal-description'>
    <h1 class='modal-info-title'>INFO</h1>
    <p class='modal-info-description'>
      {{#if info}}
        {{info}}
      {{else}}
        There is no information about this event
      {{/if}}
    </p>
    <h2 class='modal-when-title'>WHEN</h2>
    <p class='modal-when-date'>
      {{dates.start.localDate}}
      <br />
      <span
        class='modal-when-location'
      >{{dates.start.localTime}}({{_embedded.venues.0.city.name}}/{{_embedded.venues.0.country.countryCode}})</span>
    </p>
    <h2 class='modal-where-title'>WHERE</h2>
    <p class='modal-where-location'>{{_embedded.venues.0.city.name}},
      {{_embedded.venues.0.country.name}}</p>
    <p class='modal-where-address'>{{_embedded.venues.0.address.line1}}</p>
    <h2 class='modal-who-title'>WHO</h2>
    <p class='modal-who-name'>
      {{name}}
    </p>
    <h2 class='modal-prices-title'>PRICES</h2>
    <p class='modal-prices-description'>
      <svg class='icon-ticket' xmlns='http://www.w3.org/2000/svg' height='24' width='24'>
        <path fill='none' d='M0 0h24v24H0z'></path>
        <path
          d='M15 21h-2v-2h2v2zm-2-7h-2v5h2v-5zm8-2h-2v4h2v-4zm-2-2h-2v2h2v-2zM7 12H5v2h2v-2zm-2-2H3v2h2v-2zm7-5h2V3h-2v2zm-7.5-.5v3h3v-3h-3zM9 9H3V3h6v6zm-4.5 7.5v3h3v-3h-3zM9 21H3v-6h6v6zm7.5-16.5v3h3v-3h-3zM21 9h-6V3h6v6zm-2 10v-3h-4v2h2v3h4v-2h-2zm-2-7h-4v2h4v-2zm-4-2H7v2h2v2h2v-2h2v-2zm1-1V7h-2V5h-2v4h4zM6.75 5.25h-1.5v1.5h1.5v-1.5zm0 12h-1.5v1.5h1.5v-1.5zm12-12h-1.5v1.5h1.5v-1.5z'
        ></path>
      </svg>
      {{#if priceRanges.0.type}}
        {{priceRanges.0.type}}
        {{priceRanges.0.min}}
        -
        {{priceRanges.0.max}}
        {{priceRanges.0.currency}}
      {{else}}
        Purchase not available
      {{/if}}
    </p>
    <a href='{{url}}' target='_blank'>
      <button class='modal-btn buy-standart'>BUY TICKETS</button></a>
    <button class='modal-btn buy-standart basket'>ADD TO FAVORITE</button>
  </div>
</div>
<button class='modal-btn-more btn' data-more-author>
  <span class='style-search'>MORE FROM THIS AUTHOR</span></button>
`);
